import { connect } from "react-redux";

import { getManagerAccountUser } from "actions/manager_account_users";
import Users from "./Users";


const mapStateToProps = ({ manager_account_users, references }) => ({
    data: manager_account_users.list,
    loading: manager_account_users.loading,
    adminRoleList: references.admin_role_list,
});

export default connect(mapStateToProps, {
    getManagerAccountUser
})(Users);